import React, { useState, BaseSyntheticEvent } from 'react';
import { CQAppConstant } from '../../../../app-constants';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';

export const SelectRuleTypeDropDown = (props: any) => {
    const [event, setComponentEvent] = useState('');

    const [rule, setComponentRule] = useState('');

    const componentRules: any = CQAppConstant.LAYOUT_EVENT_SUB_RULE;
    const recordFormRules: any = CQAppConstant.CQ_RECORD_RULES_TYPES;
    const fieldData: any = props.fieldData;
    let applicableRules: string[] = [];
    if (!fieldData.isComponentEventRule) {
        const ruleType = (fieldData.hasOwnProperty('formula') && fieldData.type === 'Text') ? 'FORMULA_FIELD' : fieldData.type;
        const isRuleMapExist = Object.keys(CQAppConstant.RULE_TYPES_OBJECT).some((key: string) => key === ruleType.toUpperCase());
        applicableRules = isRuleMapExist ? CQAppConstant.RULE_TYPES_OBJECT[ruleType.toUpperCase()] : CQAppConstant.RULE_TYPES_OBJECT['DEFAULT'];
        if (props.selectedTemplateName) {
            const selectedUiType = CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'uiType');
            let polymorphicRuleArray = [...applicableRules]
            if (selectedUiType && selectedUiType.hasOwnProperty(fieldData.objectName) && selectedUiType[fieldData.objectName].type === 'polymorphic') {
                polymorphicRuleArray.push("dynamicSource")
                applicableRules = polymorphicRuleArray
            }
        }
        let isRuleApplied =  (applicableRules && applicableRules.length)===1?true:props.editOnly;

        return (
            <div className="slds-grid">
                <div className="slds-size_7-of-12">
                    <div className="slds-form-element slds-form-element_horizontal">
                        <label className="slds-form-element__label" >Rule Type</label>
                        <div className="slds-form-element__control">
                            <div className="slds-select_container">
                                <select className="slds-select" role = "listbox"
                                    disabled={isRuleApplied}
                                    onChange={props.onRuleTypeChanged} value={props.appliedRule}>
                                    <option value="">Please select</option>
                                    {
                                        applicableRules.map((ruleName: string) => {
                                            return (<option key={ruleName} value={recordFormRules[ruleName]['key']}>
                                                {`${recordFormRules[ruleName]['label']} (${recordFormRules[ruleName]['key']})`}
                                            </option>);
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else {
        applicableRules = Object.keys(CQAppConstant.LAYOUT_EVENT_RULES);
        const componentEvent = props.appliedRule.split('-')[0];
        const componentRule = props.appliedRule.split('-')[1];
        return (
            <>
                <div className="slds-grid">
                    <div className="slds-size_10-of-12">
                        <div className="slds-form-element slds-form-element_horizontal">
                            <label className="slds-form-element__label" >Component Event</label>
                            <div className="slds-form-element__control">
                                <div className="slds-select_container">
                                    <select className="slds-select"
                                        disabled={props.editOnly}
                                        onChange={(e: BaseSyntheticEvent) => {
                                            setComponentRule('');
                                            setComponentEvent(e.target.value);
                                            props.onComponentRuleTypeChanged('');

                                        }} value={componentEvent ? componentEvent : event}>
                                        <option value="">Please select</option>
                                        {
                                            applicableRules.map((ruleName: string) => {
                                                return (<option key={ruleName} value={CQAppConstant.LAYOUT_EVENT_RULES[ruleName]['key']}>
                                                    {`${CQAppConstant.LAYOUT_EVENT_RULES[ruleName]['label']} (${CQAppConstant.LAYOUT_EVENT_RULES[ruleName]['key']})`}
                                                </option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (event !== '' || componentEvent !== '') &&
                    <div className="slds-grid">
                        <div className="slds-size_10-of-12">
                            <div className="slds-form-element slds-form-element_horizontal">
                                <label className="slds-form-element__label" >Rule Type</label>
                                <div className="slds-form-element__control">
                                    <div className="slds-select_container">
                                        <select className="slds-select" role="rule-select"
                                            disabled={props.editOnly}
                                            onChange={(e: BaseSyntheticEvent) => {
                                                setComponentRule(e.target.value);
                                                if (e.target.value !== '') {
                                                    props.onComponentRuleTypeChanged(`${event}-${e.target.value}`);
                                                } else {
                                                    props.onComponentRuleTypeChanged('');
                                                }
                                            }
                                            }
                                            value={componentRule ? componentRule : rule}>
                                            <option value="">Please select</option>
                                            {
                                                componentRules[event ? event : componentEvent].map((ruleName: string) => {
                                                    return (<option key={ruleName} value={recordFormRules[ruleName]['key']}>
                                                        {`${recordFormRules[ruleName]['label']} (${recordFormRules[ruleName]['key']})`}
                                                    </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </>
        );
    }


};